module.exports = __webpack_public_path__ + "static/media/praxis-thumb.da969315.jpg";